import 'console-polyfill';
import 'es5-shim';

import FastClick from 'fastclick';
import $ from 'jquery';

// jquery utils
import 'jquery.easing';

import './plugins/nette.ajax';
import './plugins/giant.trigger';
import './plugins/giant.autosubmit';

import './modules/antispam';

// nette
import './nette/NetteValidationMessages';
import './nette/NetteSnippets';

import Nette from './nette/NetteForms';
window.Nette = Nette;
Nette.initOnLoad();

if ($.nette) {
    $.nette.init();
}

$(document).on('load:afterRender', function () {
    $.nette.load();
});

import xhrController from './core/xhrController';
var xhrcontroller = new xhrController;

import components from './components/';
import { loadComponents } from './core/componentUtils';

window.app = {
    components: components
};

FastClick.attach(document.body);
loadComponents();


// WEBPACK FOOTER //
// ./app.js